module.exports = __webpack_public_path__ + "static/media/logo8b.ca309075.png";